module.exports = __webpack_public_path__ + "img/second-1-opened.a91592ef.webp";